import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, LL_H_C } from '@nu-art/thunderstorm-frontend';
import { ToastItemStatus } from '../types.js';
import './ToasterItem.scss';
import { TS_Icons } from '@nu-art/ts-styles';
import { exists, resolveContent } from '@nu-art/ts-common';
import { ModuleFE_Toasting } from '../../_core/ModuleFE_Toasting.js';
const statusToClass = {
    [ToastItemStatus.Loaded]: 'loaded',
    [ToastItemStatus.Visible]: 'visible',
    [ToastItemStatus.Closed]: 'closing',
};
export const ToasterItem = (props) => {
    const className = _className('toaster-item', statusToClass[props.status]);
    return _jsxs("div", { className: className, style: {
            ...props.style,
            ['--timer-duration']: `${props.model.duration}ms`
        }, "data-variant": props.model.variant, "data-id": props.model.id, "data-duration": `${props.model.duration}ms`, children: [_jsxs(LL_H_C, { className: 'toaster-item-header', children: [_jsx("div", { className: 'toaster-item-header__title', children: resolveContent(props.model.title) }), _jsx(TS_Icons.x.component, { onClick: () => {
                            ModuleFE_Toasting.toast.close(props.model.id);
                        } })] }), exists(props.model.body) && _jsx("p", { className: 'toaster-item-body', children: resolveContent(props.model.body) }), _jsx("div", { className: 'toaster-item-timer' })] });
};
//# sourceMappingURL=ToasterItem.js.map